import React, { useState, useEffect } from "react";
import { Box, Typography, Stack } from "@mui/material";
import LoadingButton from '@mui/lab/LoadingButton';
import TableWithLoadingWrapper from "../../../../components/generic/dataGrid";
import GenericDropdown from "../../../../components/generic/genericDropdown";
import { backendGetRequest } from "../../../../helpers/callBackend";
import GenericDeleteModal from "../../../../components/buttons/genericDeleteModal";
import { message } from "antd";
import { useUcs } from '../../../../helpers/contexts/UserCompanySettingsContext'
import PermissionGate from '../../../../helpers/PermissionGate'

const SftpFilesTab = (props) => {
    const [sftpFilePageIndex, setSftpFilePageIndex] = useState(2);
    const [loadingButton, setLoadingButton] = useState({});
    const [userHasRestrictedAcces, setUserHasRestrictedAccess] = useState(true)
  
    const ucsContext = useUcs()

    useEffect(() => {
      if (ucsContext.loaded) {
        setUserHasRestrictedAccess(ucsContext.hasLimitedAccountAccess())
      }
    }, [ucsContext])

    const downloadBai2 = (fileCopyId) => {
        setLoadingButton(prevState => ({ ...prevState, [fileCopyId]: true }));
        backendGetRequest(
            "/api/sftp/file-copy/",
            { params: { file_copy_id: fileCopyId } },
        ).then((res) => {
            if (res?.data?.data?.body) {
                const blob = new Blob([res?.data?.data?.body], { type: "text/plain" }); // Adjust MIME type as needed
                const blobURL = URL.createObjectURL(blob);
                window.open(blobURL, "_blank");
                setTimeout(() => URL.revokeObjectURL(blobURL), 10000);
            } else {
                console.error("No data received to open in a new tab.");
            }
            setLoadingButton(prevState => ({ ...prevState, [fileCopyId]: false }));
        })
    }

    const columns = [
        {
            field: 'name',
            headerName: 'Filename',
            flex: 2,
            sortable: true,
            sortComparator: (a, b) => a?.localeCompare(b),
            renderCell: (params) => {
                const { row } = params;
                return (
                    <Box display="flex" alignItems="center">
                        <Typography sx={{ mt: 1.75 }}>{row?.name}</Typography>
                    </Box>
                );
            },
        },
        {
            field: 'beneficiary_name',
            headerName: '',
            flex: 1,
            align: 'right',
            renderCell: (params) => {
                const { row } = params;
                return (
                <PermissionGate
                  condition={!userHasRestrictedAcces}
                  readOnly={
                    <LoadingButton
                      disabled
                      disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                      loading={false}
                      loadingPosition="start"
                      sx={{ fontSize: 12, width: '100%', maxWidth: '150px', textTransform: 'none' }}
                    >
                      Download
                    </LoadingButton>
                  }
                  toolTipText="Users with limited account access cannot download FT files."
              >
                  <LoadingButton
                    disableElevation fullWidth size="small" type="submit" variant="contained" color="primary"
                    loading={loadingButton[row.id]}
                    loadingPosition="start"
                    onClick={() => downloadBai2(row.id)}
                    sx={{ fontSize: 12, width: '100%', maxWidth: '150px', textTransform: 'none' }}
                  >
                    Download
                  </LoadingButton>
                </PermissionGate>
                )
            },
        },
        {
            field: 'actions',
            headerName: '',
            flex: 0.1,
            type: 'actions',
            align: 'right',
            renderCell: (params) => (
                <div style={{ marginTop: 5 }}>
                    <GenericDropdown
                        dropdownItems={[
                            <GenericDeleteModal
                                type='File Copy'
                                title={`Are you sure you want to delete ${params.row.name}?`}
                                URL="/api/sftp/file-copy/"
                                deleteParams={{ 'file_copy_id': params.row.id }}
                                description={`By clicking Delete below you will no longer have the file copy ${params.row.name} on your dashboard. If you do not want to proceed or unsure, please click X on the upper right.`}
                                handleDeleteSuccess={() => props.deleteFileCopy(params.row.id)}
                                handleDeleteFailure={() => message.error(`Failed to delete the file copy ${params.row.name}`)}
                            />
                        ]}
                    />
                </div>
            )
        }
    ];

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <TableWithLoadingWrapper
                columns={columns}
                dataSource={props.files}
                loading={props.loading}
                numerator={props.numerator}
                denominator={props.denominator}
                pagination={false}
                loadMore={true}
                disableLoadMore={(props.loading || props.fileCopyPages < sftpFilePageIndex)}
                onLoadMore={() => {
                    if (props.fileCopyPages >= sftpFilePageIndex) {
                        props.getNextSourceGroupFilesPage(sftpFilePageIndex);
                        setSftpFilePageIndex(prevState => prevState + 1);
                    }
                }}
            />
        </Stack>
    );
};

export default SftpFilesTab;
